import { get } from 'lodash';
export function isSbemTheme(themeList, code) {
  return get(themeList.find(t => t.ContentCode === code), 'isSbemTheme', false);
}



// WEBPACK FOOTER //
// ./src/components/helpers/isSbemTheme.js